export const SPECIAL_12_OFF_SKU = [];
